<template>
  <v-alert
    v-if="message"
    type="error"
    dense
    variant="outlined"
    :width="alertWidth"
    transition="scroll-y-transition"
    class="custom-alert"
  >
    {{ text }}
  </v-alert>
</template>

<script>
export default {
  props: {
    // some screens pass the caught error itself
    message: [String, Object, Error],
  },
  computed: {
    text() {
      const m = this.message;
      if (!m || typeof m === "string") return m;
      const server = m.response && m.response.data && m.response.data.message;
      if (server) return Array.isArray(server) ? server.join(". ") : server;
      if (m.response && m.response.status === 403) return "Nu aveți dreptul să faceți această acțiune.";
      return "A apărut o eroare. Încercați din nou.";
    },
  },
  data() {
    return {
      alertWidth: "400px",
    };
  },
  watch: {
    message(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.$emit("clear-error");
        }, 4500);
      }
    },
  },
  mounted() {
    this.adjustWidth();
    window.addEventListener("resize", this.adjustWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.adjustWidth);
  },
  methods: {
    adjustWidth() {
      if (window.innerWidth < 600) {
        this.alertWidth = "90%";
      } else {
        this.alertWidth = "400px";
      }
    },
  },
};
</script>

<style scoped>
.custom-alert {
  position: fixed;
  top: 18px;
  left: 0;
  right: 0;
  margin: 0 auto !important;
  z-index: 9999;
  border-radius: 12px !important;
  box-shadow: var(--shadow-pop) !important;
  font-weight: 600;
  font-size: 1rem;
}
</style>
